"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileConnect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_component_library_1 = require("@snsw/react-component-library");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_use_1 = require("react-use");
var hooks_1 = require("./hooks");
var UserIdentityContextProvider_1 = require("./UserIdentityContextProvider");
var ProfileConnect = function (_a) {
    var loadingMessage = _a.loadingMessage, children = _a.children;
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var _b = (0, hooks_1.useUserIdentityReturnUrlStorage)(), storeReturnUrl = _b[1];
    var profileConnect = (0, UserIdentityContextProvider_1.useUserIdentityContext)().profileConnect;
    var disabled = profileConnect.disabled, fetchUrl = profileConnect.fetchUrl, fetchUserDetails = profileConnect.fetchUserDetails;
    var _c = (0, react_use_1.useAsync)(fetchUrl), url = _c.value, urlError = _c.error;
    var _d = (0, react_use_1.useAsync)(fetchUserDetails), userDetails = _d.value, userDetailsLoading = _d.loading, userDetailsError = _d.error;
    var error = urlError !== null && urlError !== void 0 ? urlError : userDetailsError;
    var hasUserDetails = !!userDetails;
    var shouldRedirect = !(disabled || hasUserDetails || userDetailsLoading);
    (0, react_1.useEffect)(function () {
        if (shouldRedirect && url) {
            storeReturnUrl(pathname);
            window.location.href = url;
        }
    }, [shouldRedirect, url, pathname]);
    if (disabled || hasUserDetails) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    if (error) {
        return ((0, jsx_runtime_1.jsx)(react_component_library_1.ContentContainer, { children: (0, jsx_runtime_1.jsxs)(react_component_library_1.InPageAlert, __assign({ variant: "error", title: "Profile connect failed" }, { children: [(0, jsx_runtime_1.jsx)("p", { children: "An unexpected error occurred when the Profile Connect service was called. The error message returned was:" }), (0, jsx_runtime_1.jsx)("blockquote", { children: error.message })] })) }));
    }
    return (0, jsx_runtime_1.jsx)(react_component_library_1.ComponentLoader, { fullPage: true, label: loadingMessage });
};
exports.ProfileConnect = ProfileConnect;
exports.ProfileConnect.defaultProps = {
    loadingMessage: 'Loading your profile, please wait...',
};
//# sourceMappingURL=ProfileConnect.js.map